<template>
  <div class="fixed inset-0 z-50">
    <file-detail-manager :file-id="route.params.file_id" :file-context="fileContext" />
  </div>
</template>

<script setup>
  definePageMeta({
    isLightbox: true
  });

  const route = useRoute();
  const {share_token: shareToken, user_id_or_slug: userId} = route.params;

  const album = useAlbumsStore().album;

  const fileContext = {
    contextType: FILE_CONTEXTS.album,
    contextId: album.id,
    contextSlug: album.slug,
    shareToken,
    userId,
    query: route.query
  };
</script>
